import { ErrorInfo, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { orderApi } from './api/order.api';
import { ticketApi } from './api/ticket.api';
import { useTypedDispatch } from './hooks/useTypedDispatch';
import { siteMap } from './routing/siteMap';
import { isPublicPath } from './routing/publicPaths';
import { setOrder } from './store/orderSlice';
import { setTickets } from './store/ticketSlice';
import { setCommonState } from './store/ticketCommonSlice';
import { ErrorBoundary, useErrorBoundary } from 'react-error-boundary';

export default function App() {
  const dispatch = useTypedDispatch();

  // --
  // -- Public pages (e.g. the warranty offer) are opened from an emailed link by a
  // -- visitor who has no stored order credentials. Skipping the bootstrap queries
  // -- avoids a pointless 404 and lets the router render straight away.
  // --
  const isPublic = isPublicPath(window.location.pathname);

  const {
    data: common,
    isError: isErrorCommon,
    isSuccess: isSuccessCommon,
  } = ticketApi.useGetCommonQuery({}, { skip: isPublic });
  useEffect(() => { common && dispatch(setCommonState(common)) }, [common]);

  const {
    data: order,
    isError: isErrorOrder,
    isSuccess: isSuccessOrder,
  } = orderApi.useGetOrderQuery({}, { skip: isPublic });
  useEffect(() => { order && dispatch(setOrder(order)) }, [order]);

  const {
    data: tickets,
    isError: isErrorTickets,
    isSuccess: isSuccessTickets,
  } = ticketApi.useGetTicketsQuery({}, { skip: isPublic || !order });
  useEffect(() => { tickets && dispatch(setTickets(tickets)) }, [tickets]);

  return (isPublic || isErrorOrder || isSuccessOrder)
    ? (      
      <RouterProvider
        router={createBrowserRouter(siteMap)}
        fallbackElement={<> </>}
      />
    ) : null;
}

